import { Report } from 'jzfz-web-utils';


/**
 * 页面浏览量统计类
 */
export class PVReportor {
	// 上次访问的页面
	static lastPath: string = '';
	// 上次延迟访问的页面
	static lazyLastPath: string = '';
	// 延迟统计
	static debounce: any = null;

	/**
	 * 上传统计信息
	 * @param report
	 * @param path 当前页面路径
	 * @param lazy  是否延迟统计
	 */
	static reportPV = (report: Report, path: string, lazy?: boolean) => {
		// 延迟统计
		if (lazy) {
			if (PVReportor.debounce) {
				clearTimeout(PVReportor.debounce);
			}
			PVReportor.debounce = setTimeout(() => {
				report.emit({actionId: '1608262024757', action: '', prePageUrl: PVReportor.lazyLastPath});
				PVReportor.lazyLastPath = path;
			}, 5000)
			return;
		}

		report.emit({actionId: '1620304615918', action: '', prePageUrl: PVReportor.lastPath});
		PVReportor.lastPath = path;
	}
}
